import { useState } from "react";
import { useFilter } from "./FilterContext.js";
import styles from "./Filter.module.css";
import Dropdown from "../Dropdown/Dropdown.js";

const Filter = ({
  onSearch,
  showGroupName = false,
  showGender = false,
  showAttendance = false,
}) => {
  const { countries, loading, error } = useFilter();
  const [filters, setFilters] = useState({
    country: "",
    groupName: "",
    playerName: "",
    genderLabel: "",
    attendanceLabel: "",
  });

  const handleInputChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleSearch = () => {
    onSearch(filters);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className={styles.filter}>
      <Dropdown
        props={{
          data: ["Search by Country", ...countries],
          onChange: (value) =>
            handleInputChange(
              "country",
              value === "Search by Country" ? "" : value
            ),
        }}
      />
      {showGroupName && (
        <input
          type="text"
          placeholder="Team Name" // 단체명
          value={filters.groupName}
          onChange={(e) => handleInputChange("groupName", e.target.value)}
        />
      )}
      <input
        type="text"
        placeholder="Player Name"
        value={filters.playerName}
        onChange={(e) => handleInputChange("playerName", e.target.value)}
      />
      {showGender && (
        <Dropdown
          props={{
            data: ["Gender", "M", "F"],
            onChange: (value) =>
              handleInputChange("genderLabel", value === "Gender" ? "" : value),
          }}
        />
      )}
      {showAttendance && (
        <Dropdown
          props={{
            data: ["Status", "O", "X"],
            onChange: (value) =>
              handleInputChange(
                "attendanceLabel",
                value === "Status" ? "" : value
              ),
          }}
        />
      )}
      <button className={styles.searchButton} onClick={handleSearch}>
        Search
      </button>
    </div>
  );
};
export default Filter;
